var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47363 9.57812H3.83398V11H2.47363V9.57812ZM0.169922 4.10254C0.169922 3.11816 0.447917 2.32747 1.00391 1.73047C1.5599 1.12891 2.32324 0.828125 3.29395 0.828125C4.19173 0.828125 4.90951 1.08561 5.44727 1.60059C5.98958 2.111 6.26074 2.76497 6.26074 3.5625C6.26074 4.04557 6.16048 4.4375 5.95996 4.73828C5.764 5.03906 5.36523 5.48112 4.76367 6.06445C4.32617 6.48828 4.04134 6.84831 3.90918 7.14453C3.78158 7.4362 3.71777 7.86914 3.71777 8.44336H2.50098C2.50098 7.79167 2.57845 7.26758 2.7334 6.87109C2.88835 6.47005 3.22786 6.01204 3.75195 5.49707L4.29883 4.95703C4.46289 4.80208 4.59505 4.6403 4.69531 4.47168C4.8776 4.17546 4.96875 3.86784 4.96875 3.54883C4.96875 3.10221 4.83431 2.71484 4.56543 2.38672C4.30111 2.05859 3.86133 1.89453 3.24609 1.89453C2.48503 1.89453 1.95866 2.17708 1.66699 2.74219C1.50293 3.05664 1.40951 3.51009 1.38672 4.10254H0.169922Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/questionIcon.4b6f7426d02cc2ee4a104b5c56bd63de.svg";
export { ForwardRef as ReactComponent };